<template>
    <SecondaryPage>
        <div class="relative max-full-hd">
            <BackButtonDesktop @clickBack="clickBack()"></BackButtonDesktop>
            <div class="max-w-sm m-auto py-8 px-6">
                <div class="text-a-brown-502314 text-24 text-center font-bold mb-6">
                    {{lbl.login.welcome_burgerking}}
                </div>
                <InputContactNumber
                        v-model:inputValue="phoneNumber"
                        :maxLength="12"
                        delimeter="-"
                        :errorInfo="errorInfo[0]"
                        :isShowError="false"
                        :isSubmitted="false"
                        :inputLbl="lbl.login.phoneNo"
                ></InputContactNumber>
                <RedButton @click="clickSignIn()">
                    <div class="text-18 font-bold">{{lbl.login.sign_in}}</div>
                </RedButton>
                <div class="text-center text-a-brown-825f50 text-16 my-8">
                    {{lbl.login.or}}
                </div>
                <WhiteBtnBlackBorder class="mb-4" @click="clickLoginFacebook()">
                    <div class="flex items-center justify-center">
                        <div class="mr-3"><img class="w-22px" src="../../../assets/login/Facebook.svg"></div>
                        <div>Sign in with Facebook</div>
                    </div>
                </WhiteBtnBlackBorder>
                <WhiteBtnBlackBorder class="mb-4" @click="clickLoginGoogle()">
                    <div class="flex items-center justify-center">
                        <div class="mr-3"><img class="w-22px" src="../../../assets/login/google.svg"></div>
                        <div>Sign in with Google</div>
                    </div>
                </WhiteBtnBlackBorder>
                <!-- <WhiteBtnBlackBorder>
                    <div class="flex items-center justify-center">
                        <div class="mr-3"><img class="w-22px" src="../../../assets/login/Apple.svg"></div>
                        <div>Sign in with Apple ID</div>
                    </div>
                </WhiteBtnBlackBorder> -->
                <div class="text-16 text-a-brown-502314 text-center mt-14 mb-3">
                    {{lbl.login.don_t_have_an_account}}
                </div>
                <WhiteButton @click="clickRegister()">
                    <div class="font-bold text-18">{{lbl.login.create_account}}</div>
                </WhiteButton>
                <div class="text-18 text-center mt-8">
                    {{lbl.login.continue_as}} <span class="font-bold text-a-red-d62300 cursor-pointer" @click="clickLoginGuest()">{{lbl.login.guest}}</span>
                </div>
            </div>
        </div>
    </SecondaryPage>
</template>
<script>
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import { FormHelper } from '@/helper/FormHelper';
import RegxHelper from '@/helper/RegxHelper';
import CacheHelper from '@/helper/CacheHelper';
import { CacheKey } from '@/helper/StaticValue';
import FBFunction from '@/helper/facade/FBFunction'
//components
import SecondaryPage from '@/components/Layout/Page/SecondaryPage.vue'
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue'
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue'
import RedButton from '@/components/Button/RedButton.vue';
import WhiteBtnBlackBorder from '@/components/Button/WhiteBtnBlackBorder.vue';
import WhiteButton from '@/components/Button/WhiteButton.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
//service
import LoginAccountApi from '../service/LoginAccountApi';
import BzbsOtp from '@/core/Account/service/BzbsOtp';
import { AuthFacebookConfigBuilder,AuthGoogleConfigBuilder } from '@/core/Account/config/AuthConfigModel';
import BzbsAuth from '@/core/Account/service/BzbsAuth';
import useFirebaseAuth from '../composable/useFirebaseAuth';

export default {
    mixins: [LocaleMixin, ModalMixin],
    components: {
        SecondaryPage,
        BackButtonDesktop,
        InputContactNumber,
        RedButton,
        WhiteBtnBlackBorder,
        WhiteButton,
    },
    data: function () {
        return {
            phoneNumber: '',
            errorInfo: FormHelper.genErrorInfo(1),

            pathAfterLogin: null,
        };
    },
    setup: function () {
        const googleAuth = useFirebaseAuth()
        return {
            googleAuth
        }
    },
    created: function () {
        this.tracking.screenName('register');
        this.tracking.event('register','view_login', null, null);
        let afterLogin = this.$route.query.afterLogin;
        if (!Util.isEmptyStr(afterLogin)) {
            this.pathAfterLogin = afterLogin;
        }

        this.checkLoginGoogle();

    },
    mounted: function () {
        this.modal.loadingModal.show();
    },
    methods: {
        clickLoginGuest: function () {
            this.tracking.event('register','click_guest_login', null, null);
            this.openNextPage('login_guest');
        },
        clickRegister: function () {
            this.tracking.event('register','click_new_register', null, null);
             this.openNextPage('register');
            // this.$router.push('/register');
        },

        clickSignIn: async function () {
            if (RegxHelper.isContactNumber(this.phoneNumber)) {
                // this.openLoginPassword()
                let data = await this.checkAccountPasswordStatus();
                if (data == null) {
                    return;
                }
                // console.log('account status', data);
                this.tracking.event('register','click_login', null, null);
                if (data.needResetPassword) {
                    // flow reset pin
                    this.openOtpResetPassword();
                } else {
                    this.openLoginPassword(this.phoneNumber);
                }
            }
        },
        openLoginPassword: function (username) {
            let userData = {
                username: username,
            };
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.loginUsername, userData);

            // this.$router.push('/login/password');
            this.openNextPage('login_password')
        },
        checkAccountPasswordStatus: function () {
            return new Promise((resolve) => {
                LoginAccountApi.checkAccountLoginStatus(this.phoneNumber).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(data);
                    },
                    error: (err) => {
                        resolve(null);
                        this.errorApi(err);
                    },
                });
            });
        },

        openNextPage: function (pathName) {
            let query = null;
            if (this.pathAfterLogin != null) {
                query = {
                    afterLogin: this.pathAfterLogin,
                };
            }
            this.$router.replace({
                name: pathName,
                query: query,
            });
        },

        //#region OTP set password
        openOtpResetPassword: function () {
            this.modal.otpModal
                .clearModal()
                .setTel(this.phoneNumber)
                .setEnableRequestOtp()
                .setOtpChanel('newpin')
                .startOtp();

            this.modal.otpModal.onSubmitOtp(async (otpModel) => {
                console.log('submit otp', otpModel);
                let rs = await this.validateOtpResetPassword(otpModel);
                if (rs) {
                    this.modal.otpModal.closeOtp();
                    this.openResetPassword(otpModel);
                }
            });
        },
        validateOtpResetPassword: function (otpModel) {
            return new Promise((resolve) => {
                BzbsOtp.validateOtpAndUse(otpModel.contactNumber, otpModel.refcode, otpModel.otp, otpModel.channel).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);

                        if (err.id == 2091) {
                            this.modal.otpModal.setErrorMsg('Invalid OTP, please try again.');
                            this.modal.otpModal.clearInputOtp();
                        } else {
                            this.errorApi(err);
                        }
                    },
                });
            });
        },
        openResetPassword: function (otpModel) {
            let cache = new CacheHelper('session');
            cache.setCache(CacheKey.setPasswordOtp, otpModel);

            this.$router.push('/login/setnewpassword');
        },
        //#endregion OTP set password

        //#region Facebook
        clickLoginFacebook: async function () {
            this.tracking.event('register','click_facebook_login', null, null);
            let fbLoginStatus = await this.fbLoginStatus()
            if (fbLoginStatus == null) {
                fbLoginStatus = await this.loginFB();
            }

            if (fbLoginStatus != null) {
                let fbAccessToken = fbLoginStatus.accessToken;
                console.log('access token', fbAccessToken);
                this.loginFacebookBzbs(fbAccessToken);
            }
        },
        fbLoginStatus: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.getLoginStatus().then((fbData) => {
                    console.log('fb login status', fbData);
                    resolve(fbData);
                }).catch(() => {
                    resolve(null);
                    console.log('fb error');
                });
            });
        },
        loginFB: function () {
            return new Promise((resolve) => {
                let fb = new FBFunction();
                fb.login().then((data) => {
                    console.log('fb login', data);
                    resolve(data);
                }).catch(() => {
                    console.log('fb login error');
                    resolve(null);
                });
            });
        },
        loginFacebookBzbs: async function (fbAccessToken) {
            console.log(fbAccessToken);
            let authConfig = new AuthFacebookConfigBuilder()
                .genUUID()
                .setFacebookToken(fbAccessToken)
                .create()
                .getParams();

            this.modal.loadingModal.show();
            let loginRs = await this.apiLoginFacebook(authConfig)
            this.modal.loadingModal.hide();

            if (loginRs) {
                this.afterLoginRedirect();
            }
        },
        apiLoginFacebook: function (params) {
            return new Promise((resolve) => {
                BzbsAuth.apiLoginFacebook(params).subscribe({
                    next: (user) => {
                        Account.setLogin(user);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        if (err.id == '2123') {
                            this.openNextPage('register_facebook');
                            return;
                        }

                        this.errorApi(err);
                    },
                })
            });
        },
        //#endregion Facebook

        //#region Google
        clickLoginGoogle: async function () {
            this.tracking.event('register','click_google_login', null, null);
            this.googleAuth.signInWithRedirect();
            // this.googleAuth.signInWithPopup().then((token)=>{
            //     console.log(token);
            //     console.log(this.googleAuth.user.value);
            //     if (token.idToken) {
            //         this.loginGoogleBzbs(token.idToken);
            //     }
            // })
        },
        checkLoginGoogle: function () {
            this.googleAuth.getRedirectResult().then((token)=>{
                this.modal.loadingModal.hide();
                if (token && token.idToken) {
                    this.loginGoogleBzbs(token.idToken);
                }
            });
        },
        loginGoogleBzbs: async function (ggAccessToken) {
            let authConfig = new AuthGoogleConfigBuilder()
                .setGoogleToken(ggAccessToken)
                .create()
                .getParams();

            this.modal.loadingModal.show();
            let loginRs = await this.apiLoginGoogle(authConfig)
            this.modal.loadingModal.hide();

            if (loginRs) {
                this.afterLoginRedirect();
            }
        },
        apiLoginGoogle: function (params) {
            return new Promise((resolve) => {
                BzbsAuth.apiLoginGoogle(null,params).subscribe({
                    next: (user) => {
                        console.log(user);
                        Account.setLogin(user);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        if (err.id == '2123') {
                            this.openNextPage('register_google');
                            return;
                        }

                        this.errorApi(err);
                    },
                })
            });
        },
        //#endregion Google

        afterLoginRedirect: function () {
            if (this.pathAfterLogin == null) {
                window.location.replace('/home');
                // this.$router.replace('/home');
            } else {
                window.location.replace(this.pathAfterLogin);
                // this.$router.replace(this.pathAfterLogin);
            }
        },
        clickBack: function () {
            this.$router.back();
        }
    },
}
</script>
<style lang="scss" scoped>
@import '@/style/base/display.scss';

</style>
